export const NOT_HANDLED = 'Not handled'
export const ALL = 'All'
